
import { Injectable, signal } from "@angular/core";
import { Layout, LayoutRepository } from "../data-store.types";


@Injectable()
export class LocalLayoutStorageService implements LayoutRepository<Layout> {

    allLayouts = signal(<Layout[]>[]);

    public constructor () {
        this._setAllLayouts();
    }

    addLayout(layout: Layout): boolean {
        const layouts = JSON.parse(<string>localStorage.getItem("layouts")) || [];
        layouts.push(layout);
        localStorage.setItem("layouts", JSON.stringify(layouts));
        this._setAllLayouts();
        return true;
    }

    deleteLayout(name: string): boolean {
        const layouts: Layout[] = JSON.parse(<string>localStorage.getItem("layouts")) || [];
        const newLayoutList: Layout[] = layouts.filter(l => l.name !== name);
        localStorage.setItem("layouts", JSON.stringify(newLayoutList));
        this._setAllLayouts();
        // TODO: Do we need a warning prompt?
        return true;
    }

    //FIXME: Remove this disabling tag
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateLayout(layout: Layout): boolean {
        throw new Error("Method not implemented.");
    }

    findLayout(name: string): Layout {
        const layouts: Layout[] = JSON.parse(<string>localStorage.getItem("layouts")) || [];
        const layout: Layout | undefined = layouts.find(l => l.name === name);
        if (!layout) {
            throw new Error(`Unable to find the layout : ${name}`);
        }
        return layout;
    }

    _setAllLayouts() {
        const layouts: Layout[] = JSON.parse(<string>localStorage.getItem("layouts")) || [];
        this.allLayouts.set(layouts);
    }
}
